import { CalendarManager, Economics, ISetParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchEconomics = (session: Session, params: ISetParams = {}, pageSize = 100): Promise<Economics[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('economics', { ...params, pageSize })
    .then(res => (res.ok ? res.ok : []))
    .catch(error => {
      logCalendarFetchFailure('economic', error);
      return [];
    });
};

export { fetchEconomics };
